import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Sunset"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 19.5039H22.4985V21.0039H1.5V19.5039ZM12 15.0039C13.656 15.006 14.9979 16.3479 15 18.0039H16.5C16.5 15.5186 14.4853 13.5039 12 13.5039C9.51472 13.5039 7.5 15.5186 7.5 18.0039H9C9.00207 16.3479 10.344 15.006 12 15.0039ZM18.75 16.5039H22.5V18.0039H18.75V16.5039ZM16.2654 12.6781L18.8949 10.0486L19.9554 11.1091L17.3259 13.7386L16.2654 12.6781ZM14.6925 7.19641L12.75 9.13141V3.00391H11.25V9.13141L9.3075 7.19641L8.25 8.25391L12 12.0039L15.75 8.25391L14.6925 7.19641ZM4.04561 11.1091L5.10611 10.0486L7.73561 12.6781L6.67436 13.7386L4.04561 11.1091ZM1.5 16.5039H5.25V18.0039H1.5V16.5039Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Sunset.vue"]]);
